<div style="padding: 24px;text-align: center;background: #0E0D0D;">
  <div style="font-size:18px;font-weight:700">{{title}}</div>
  <div style="margin-top:8px;margin-bottom:16px;color: #dedede;opacity: 0.7;font-size:14px">{{description}}</div>
  <div style="display: flex; justify-content: center">
    <button mat-button (click)="cancel()" class="cancel_button">
      {{cancelText}}</button>
    <button mat-button (click)="confirm()" class="confirm_button">
      {{confirmText}}</button>
  </div>
</div>